import { Recommendation } from '../patientAdvisory';

export enum CareGapProcessingStatus {
  NeedsManualProcessing = 'NEEDS_MANUAL_PROCESSING',
  ProcessedAutomatically = 'PROCESSED_AUTOMATICALLY',
  ProcessedManually = 'PROCESSED_MANUALLY',
}

export interface Document {
  careGapProcessingStatus: CareGapProcessingStatus;
  created: string;
  date: string | null;
  facility: string | null;
  gsPath: string | null;
  id: string;
  kind: Recommendation;
  textGsPath: string | null;
  title: string | null;
}

export interface DocumentItem extends Document {
  practiceName: string | null;
  organizationName: string | null;
}

export interface DocumentText {
  text: string;
}

export interface FilterOptions {
  after?: Date;
  before?: Date;
  kinds?: Recommendation[];
  ehrInformationIds?: string[];
  organizationIds?: string[];
  practiceIds?: string[];
  careGapProcessingStatus?: CareGapProcessingStatus[];
}
